<ng-container *ngIf="report">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2>Field Usage</h2>
    <mat-icon (click)="closeSideBar()" class="sidebar-close-button">close</mat-icon>
  </div>
  <p><b>Type: </b>{{ report.associatedType }} {{ uiName }}</p>
  <div fxLayout="row" fxLayoutGap="10">
    <div class="usage-count">
      <p>{{ report.associatedCount }}</p>
      <p>{{ report.associatedUageTypeName }} with values</p>
    </div>
    <div class="usage-count">
      <p>{{ report.associatedForms.length }}</p>
      <p>On Forms, Surveys, or Evaluations</p>
    </div>
  </div>
  <p *ngIf="report.associatedForms.length > 0" class="mb-0"><b>Used on the following:</b></p>
  <div *ngFor="let form of forms$ | async" fxLayout="row" fxLayoutGap="10">
    <div fxLayout="row" fxFlex="50">
      <p class="form-title" (click)="navigateTo(form)">{{ form.title }}</p>
    </div>
    <div fxLayout="row" fxFlex="50" fxLayoutAlign="start">
      <p>{{ form.formTypeName }} {{ form.isClosed ? '(Closed)' : '(Open)' }}</p>
    </div>
  </div>
</ng-container>
